import { render, staticRenderFns } from "./GoodIssueDisplayView.vue?vue&type=template&id=2c58f2b3"
import script from "./GoodIssueDisplayView.vue?vue&type=script&lang=js"
export * from "./GoodIssueDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports